const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="text-center text-sm text-stone-500 py-4">
      <p>&copy; {year} Listography. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
